import { Base64 } from 'js-base64';
// tslint:disable-next-line: no-submodule-imports
import * as lib from '@altibox/lib/dist/api';

import { FormSubmitionValues } from '../types';
import { DefaultResponse, UserPinResponse, UserCreateResponse } from './types';

// const mockApiResponses = {
//   UserPinSuccess: 'http://www.mocky.io/v2/5e2acb5032000080001c6df3?mocky-delay=2200ms',
//   UserCreatedSuccess: 'http://www.mocky.io/v2/5e2b09e13200002c001c7058?mocky-delay=2200ms', // success, offcode sent
//   UserFinalizedSuccess: 'http://www.mocky.io/v2/5e30050532000072008586c5?mocky-delay=2200ms', // user created
//   6003: 'http://www.mocky.io/v2/5e2855a33200005200d84168?mocky-delay=1000ms', // failure, User not authenticated
//   6004: 'http://www.mocky.io/v2/5e30177d3200005b00858788?mocky-delay=1000ms', // user already exists
//   6005: 'http://www.mocky.io/v2/5e2f04313100005b007104ad?mocky-delay=1000ms', // expected another CRM system
//   6008: 'http://www.mocky.io/v2/5e2ec16a3100006c00710213?mocky-delay=1000ms', // invalid offcode
//   6010: 'http://www.mocky.io/v2/5e2acfae3200007c001c6e19?mocky-delay=1000ms', // Password not strong: Password is too short
//   6013: 'http://www.mocky.io/v2/5e3420ab300000056fd962f2?mocky-delay=1000ms', // username taken
// };

enum Api {
  UserPin = '/api/authentication/user/pin',
  UserCreate = '/api/authentication/user/create',
  UserFinalize = '/api/authentication/user/finalize',
  ForgotPin = '/api/authentication/pin/sendpinmail',
}

// Step 1/3: This function is the first step in the create new user flow.
export const userPin = async ({ customerNumber, pin }: FormSubmitionValues) => {
  return lib.fetchJson<UserPinResponse>(Api.UserPin, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ customerNumber, pin }),
  }).catch(r => r.json());
};

// Step 2/3: function is the second step in the create new user flow
export const userCreate = async ({ flowKey, email, password, countryCode }: UserCreateParams) => {
  return lib.fetchJson<UserCreateResponse>(Api.UserCreate, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ flowKey, username: email, password: Base64.encode(password), countryCode }),
  }).catch(r => {
    return r.json();
  });
};

// Step 3/3:
export const userFinalize = async (params: FinalizeParams) => {
  return lib.fetchJson<DefaultResponse>(Api.UserFinalize, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  }).catch(r => {
    return r.json();
  });
};

export const forgotPin = async (params: ForgotPinParams) => {
  return lib.fetchJson<DefaultResponse>(Api.ForgotPin, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: `partnerid=${params.partnerid}&customerid=${params.customerid}`,
  }).catch(r => {
    return r.json();
  });
};

interface FinalizeParams {
  flowKey: string;
  offcode: string;
}

interface UserCreateParams {
  flowKey: string;
  email: string;
  password: string;
  countryCode: string;
}

interface ForgotPinParams {
  partnerid: string;
  customerid: string;
}
